export default __webpack_public_path__ + "static/media/clock-icon.541e0c64.png";